// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","masterPlanPage":"master-plan-portal-page_masterPlanPage__mY8jR","help":"master-plan-portal-page_help__5K8Tp"};